/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MemberStore from '../../stores/MemberStore';
import MatchesStore from '../../stores/MatchesStore';
import MatchesActionCreators from '../../actions/MatchesActionCreators';
import MatchesMembersItem from '../../components/matches/MatchesMembersItem';
import { ImageSvg } from '../../components/image';
import Pagination from '../../components/pagination';
import MatchesFooter from '../../components/matches/MatchesFooter';

class MatchesMembersContainer extends Component {
  state = {
    matches: [],
    total: null,
    page: this.props.page,
    loading: true,
    usersNotFound: false,
    error: false,
    message: null,
    unseen: [],
    noAboLimitReached: this.props.noAboLimitReached,
  };

  memberContainer = React.createRef();

  componentDidMount() {
    const {
      api,
      page,
      itemsPerPage,
      noAboLimitReached,
    } = this.props;

    MatchesStore.setNoAboLimitReached(noAboLimitReached);

    MatchesStore.addChangeListener(this.onChange);

    MatchesActionCreators.loadMatchesMembers(api, page, itemsPerPage);
  }

  componentWillUnmount() {
    MatchesStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      matches: MatchesStore.getMatches(),
      total: MatchesStore.getMatchesTotal(),
      page: MatchesStore.getMatchesPage(),
      loading: MatchesStore.getLoading(),
      usersNotFound: MatchesStore.getUsersNotFound(),
      error: MatchesStore.getError(),
      message: MatchesStore.getMessage(),
      unseen: MatchesStore.getUnseen(),
      noAboLimitReached: MatchesStore.getNoAboLimitReached(),
    });
  };

  updateQueryStringParameter = (uri, key, value) => {
    const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
      return uri.replace(re, `$1${key}=${value}$2`);
    }
    return `${uri + separator + key}=${value}`;
  };

  handlePageChange = (page) => {
    MatchesStore.setMatches([]);
    MatchesStore.setMatchesPage(page);
    MatchesStore.setLoading(true);
    MatchesStore.emitChange();

    const { api, itemsPerPage } = this.props;
    MatchesActionCreators.loadMatchesMembers(api, page, itemsPerPage);

    let url = window.location.href;
    url = this.updateQueryStringParameter(url, 'page', page);

    if (window.history.pushState) {
      const historyState = {
        id: (new Date()).getTime(),
        url,
        container: '#content',
      };
      window.history.pushState(historyState, '', url);
    }

    // this.memberContainer.current.scrollIntoView({ behavior: 'smooth', block: 'start'});
    this.memberContainer.current.scrollIntoView();
  };

  handleVote = (memberId, newVote) => {
    const { page } = this.state;
    const { api, itemsPerPage } = this.props;

    MatchesStore.setLoading(true);
    MatchesStore.emitChange();

    MatchesActionCreators.matchesVote(memberId, newVote, { api, page, itemsPerPage });
  };

  render() {
    const {
      matches,
      total,
      page,
      loading,
      usersNotFound,
      error,
      message,
      unseen,
      noAboLimitReached,
    } = this.state;

    const { itemsPerPage, includeSkip } = this.props;

    const memberItems = () => {
      if (usersNotFound || error) {
        return (
          <div
            className="pal"
            dangerouslySetInnerHTML={{ __html: message }}
          />
        );
      }

      const items = [];
      matches.forEach((match) => {
        const member = MemberStore.get(match.reference_id);
        let action = '';
        if (match.types.includes('like')) {
          action = 'like';
        } else if (match.types.includes('dislike')) {
          action = 'dislike';
        } else if (match.types.includes('skip')) {
          action = 'skip';
        }

        items.push(
          <MatchesMembersItem
            key={match.reference_id}
            member={member}
            action={action}
            updated={match.match_updated ? parseInt(match.match_updated.$date.$numberLong, 10) : 0}
            handleVote={this.handleVote}
            includeSkip={includeSkip}
            unseen={unseen.includes(match._id)}
            noAboLimitReached={noAboLimitReached}
          />,
        );
      });

      return (
        <div>{items}</div>
      );
    };

    const pagination = () => {
      if (loading || total <= itemsPerPage) {
        return (null);
      }

      return (
        <div className="content-pagination">
          <Pagination
            activePage={page}
            itemsCountPerPage={itemsPerPage}
            totalItemsCount={total}
            pageRangeDisplayed={5}
            innerClass="pagination clearfix"
            prevPageText={(
              <span className="btn-static">
                <span className="vcenter">
                  <span className="vcenter-inner">
                    <ImageSvg svg="icon-arrowleft" iconClass="icon--arrowLeft" />
                  </span>
                </span>
              </span>
            )}
            nextPageText={(
              <span className="btn-static">
                <span className="vcenter">
                  <span className="vcenter-inner">
                    <ImageSvg svg="icon-arrowright" iconClass="icon--arrowRight" />
                  </span>
                </span>
              </span>
            )}
            firstPageText=""
            lastPageText=""
            hideNavigation
            activeLinkClass="active"
            linkClassPrev={`btn btn--b btn--oneIcon pagination-prev${page === 1 ? ' btn--disabled' : ''}`}
            linkClassNext={`btn btn--b btn--oneIcon pagination-next${total <= (page * itemsPerPage) ? ' btn--disabled' : ''}`}
            onChange={this.handlePageChange}
            section="matches"
          />
        </div>
      );
    };

    return (
      <div>
        <div className={`matches-members${includeSkip ? ' matches-members-r2' : ''} block group mbm${loading ? ' loading' : ''}`} ref={this.memberContainer}>
          {loading && (
            <div className="loading-spinner" />
          )}
          {memberItems()}
        </div>
        {pagination()}
        {!loading && (
          <MatchesFooter
            pagination={total > itemsPerPage}
          />
        )}
      </div>
    );
  }
}

MatchesMembersContainer.propTypes = {
  api: PropTypes.string,
  page: PropTypes.number,
  itemsPerPage: PropTypes.number,
  includeSkip: PropTypes.bool,
  noAboLimitReached: PropTypes.bool,
};

MatchesMembersContainer.defaultProps = {
  api: '',
  page: 1,
  itemsPerPage: 20,
  includeSkip: false,
  noAboLimitReached: false,
};

export default MatchesMembersContainer;
